import { ApiException } from '@repo/api-gw-sdk';

// Removing an exclusion that is already gone (e.g. removed from another tab) has reached the state the caller asked for.
export const ignoreNotFound = (error: unknown): void => {
  if (error instanceof ApiException && error.code === 404) {
    return;
  }
  throw error;
};
